import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Grid, Card, Box, Button, Typography } from "@material-ui/core";
import CardContent from '@material-ui/core/CardContent';
import Alert from '@material-ui/lab/Alert';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import DownloadIcon from '@material-ui/icons/GetApp';
import TicketIcon from '@material-ui/icons/ConfirmationNumber';
import { useParams } from "react-router-dom";
import ParkService from "./Locality/Service/parkService";
import AdvertisementBanner from "../../components/AdvertisementBanner/AdvertisementBanner";
export default function Success(props) {
  const { bookingId, parkId } = useParams();
  const [ticketBooking, setTicketBookingList] = useState({
    status: 'info',
    image: "",
    message: "",
    parkId: "",
    id: ""
  });
  const [advtDetails, setAdvtDetails] = useState([]);

  // Memoize handlers with useCallback
  const handleRedirect = useCallback(() => {
    props.history.push(`/ticketbooking/${parkId}`);
  }, [props.history, parkId]);

  const getQRCode = useCallback(() => {
    props.history.push(`/getqr/${parkId}`);
  }, [props.history, parkId]);

  // Optimize API calls with useCallback
  const getAdvByIdList = useCallback(() => {
    if (!parkId) return;
    
    ParkService.getAdvbyById({ parkId: parkId }).then((res) => {
      if (res && res.advatagement) {
        setAdvtDetails(res.advatagement);
      }
    }).catch((err) => {
      // Silently handle error - could add error state if needed
      console.error('Failed to load advertisements:', err);
    });
  }, [parkId]);

  const getByIdList = useCallback(() => {
    if (!bookingId || !parkId) return;

    ParkService.getQRcodebyById({ bookingId: bookingId, parkId: parkId }).then((res) => {
      if (res) {
        if (res.status) {
          setTicketBookingList({
            ...res,
            status: 'success'
          });
        } else {
          setTicketBookingList({
            status: 'error',
            image: "",
            message: res.message || 'Failed to load QR code',
            id: ""
          });
        }
      } else {
        setTicketBookingList({
          status: 'error',
          image: "",
          message: res?.message || 'No data received',
          id: ""
        });
      }
    }).catch((err) => {
      setTicketBookingList({
        status: 'error',
        image: "",
        message: err?.response?.data?.message || 'Failed to load booking details',
        id: ""
      });
    });
  }, [bookingId, parkId]);

  // Load data on mount - run API calls in parallel
  useEffect(() => {
    getByIdList();
    getAdvByIdList();
  }, [getByIdList, getAdvByIdList]);

  // Load Google Ad script only once
  // useEffect(() => {
  //   const existingScript = document.querySelector('script[src*="adsbygoogle"]');
  //   if (existingScript) return;

  //   const script = document.createElement('script');
  //   script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-2277440900291589";
  //   script.async = true;
  //   script.crossOrigin = "anonymous";
  //   document.body.appendChild(script);

  //   return () => {
  //     const scriptToRemove = document.querySelector('script[src*="adsbygoogle"]');
  //     if (scriptToRemove && scriptToRemove === script) {
  //       document.body.removeChild(script);
  //     }
  //   };
  // }, []);

  // Memoize derived values
  const isSuccess = useMemo(() => ticketBooking.status === 'success', [ticketBooking.status]);
  const hasImage = useMemo(() => Boolean(ticketBooking.image), [ticketBooking.image]);

  // Check if mobile device
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <Box
      style={{
        minHeight: '100vh',
        background: '#f5f7fa',
        padding: isMobile ? '10px' : '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Grid container spacing={isMobile ? 2 : 3} justifyContent="center" style={{ maxWidth: '800px', width: '100%' }}>
        {/* Success Card */}
        <Grid item xs={12}>
          <Card
            style={{
              borderRadius: isMobile ? '15px' : '20px',
              boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
              overflow: 'hidden',
              background: '#ffffff',
              width: '100%'
            }}
          >
            <CardContent style={{ padding: isMobile ? '20px' : '40px' }}>
              {/* Success Icon & Message */}
              {isSuccess ? (
                <Box style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <Box
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #3CD4A0 0%, #2ecc71 100%)',
                      marginBottom: '20px',
                      boxShadow: '0 10px 30px rgba(60, 212, 160, 0.4)',
                      animation: 'scaleIn 0.5s ease-out'
                    }}
                  >
                    <CheckCircleIcon style={{ fontSize: '60px', color: '#ffffff' }} />
                  </Box>
                  <Typography
                    variant="h4"
                    style={{
                      fontWeight: 'bold',
                      color: '#2c3e50',
                      marginBottom: '10px',
                      fontSize: '28px'
                    }}
                  >
                    Booking Confirmed! 
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: '#7f8c8d',
                      fontSize: isMobile ? '14px' : '16px',
                      marginBottom: isMobile ? '20px' : '30px',
                      padding: isMobile ? '0 10px' : '0'
                    }}
                  >
                    {ticketBooking.message || 'Your ticket has been successfully booked'}
                  </Typography>
                </Box>
              ) : (
                <Box style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <Box
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: isMobile ? '80px' : '100px',
                      height: isMobile ? '80px' : '100px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                      marginBottom: isMobile ? '15px' : '20px',
                      boxShadow: '0 10px 30px rgba(231, 76, 60, 0.4)',
                      animation: 'scaleIn 0.5s ease-out'
                    }}
                  >
                    <ErrorIcon style={{ fontSize: isMobile ? '45px' : '60px', color: '#ffffff' }} />
                  </Box>
                  <Typography
                    variant="h4"
                    style={{
                      fontWeight: 'bold',
                      color: '#2c3e50',
                      marginBottom: '10px',
                      fontSize: isMobile ? '22px' : '28px',
                      padding: isMobile ? '0 10px' : '0'
                    }}
                  >
                    Booking Failed! 
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: '#7f8c8d',
                      fontSize: isMobile ? '14px' : '16px',
                      marginBottom: '20px',
                      padding: isMobile ? '12px 15px' : '15px 20px',
                      background: '#fff5f5',
                      borderRadius: '10px',
                      border: '1px solid #fed7d7',
                      maxWidth: '500px',
                      margin: '0 auto 30px',
                      lineHeight: '1.6'
                    }}
                  >
                    {ticketBooking.message || 'We encountered an issue processing your booking. Please try again.'}
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      color: '#95a5a6',
                      fontSize: isMobile ? '12px' : '14px',
                      fontStyle: 'italic',
                      padding: isMobile ? '0 10px' : '0'
                    }}
                  >
                    If the problem persists, please contact our support team.
                  </Typography>
                </Box>
              )}

              {/* QR Code Display - Only show if image exists */}
              {hasImage && isSuccess && (
                <>
                  <Box
                    style={{
                      textAlign: 'center',
                      marginBottom: isMobile ? '20px' : '30px',
                      padding: isMobile ? '20px' : '30px',
                      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                      borderRadius: '15px',
                      border: isMobile ? '2px dashed #3CD4A0' : '3px dashed #3CD4A0'
                    }}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        fontWeight: '600',
                        color: '#2c3e50',
                        marginBottom: isMobile ? '15px' : '20px',
                        textAlign: 'center',
                        fontSize: isMobile ? '18px' : '20px'
                      }}
                    >
                      Your Entry QR Code
                    </Typography>
                    <Box
                      style={{
                        display: 'inline-block',
                        padding: isMobile ? '15px' : '20px',
                        background: '#ffffff',
                        borderRadius: '15px',
                        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                        marginBottom: isMobile ? '15px' : '20px'
                      }}
                    >
                      <img
                        src={ticketBooking.image}
                        alt="QR Code"
                        style={{
                          width: isMobile ? '200px' : '250px',
                          height: isMobile ? '200px' : '250px',
                          maxWidth: '100%',
                          display: 'block'
                        }}
                      />
                    </Box>
                    <Typography
                      variant="body2"
                      style={{
                        color: '#e67e22',
                        fontWeight: '600',
                        marginTop: '15px',
                        fontSize: isMobile ? '12px' : '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px',
                        flexWrap: 'wrap',
                        textAlign: 'center',
                        padding: isMobile ? '0 10px' : '0'
                      }}
                    >
                      ⚠️ Show this QR code at the entry gate
                    </Typography>
                  </Box>

                  {/* Download Button - Only show if image exists */}
                  <Box
                    style={{
                      display: 'flex',
                      gap: isMobile ? '10px' : '15px',
                      justifyContent: 'center',
                      flexWrap: 'wrap',
                      marginBottom: isMobile ? '20px' : '30px'
                    }}
                  >
                    <Button
                      variant="contained"
                      startIcon={<DownloadIcon />}
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = ticketBooking.image;
                        link.download = 'qr-code.png';
                        link.click();
                      }}
                      style={{
                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        color: '#ffffff',
                        padding: isMobile ? '10px 20px' : '12px 30px',
                        borderRadius: '25px',
                        fontWeight: '600',
                        textTransform: 'none',
                        fontSize: isMobile ? '13px' : '15px',
                        boxShadow: '0 5px 15px rgba(102, 126, 234, 0.4)',
                        transition: 'all 0.3s ease',
                        width: isMobile ? '100%' : 'auto',
                        '&:hover': {
                          transform: 'translateY(-2px)',
                          boxShadow: '0 8px 20px rgba(102, 126, 234, 0.5)'
                        }
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.5)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 5px 15px rgba(102, 126, 234, 0.4)';
                      }}
                    >
                      Download QR Code
                    </Button>
                  </Box>
                </>
              )}

              {/* Navigation Buttons */}
              <Box
                style={{
                  display: 'flex',
                  gap: isMobile ? '10px' : '15px',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  paddingTop: isMobile ? '15px' : '20px',
                  borderTop: '2px solid #ecf0f1',
                  flexDirection: isMobile ? 'column' : 'row'
                }}
              >
                <Button
                  variant="outlined"
                  startIcon={<TicketIcon />}
                  onClick={handleRedirect}
                  style={{
                    borderColor: 'rgb(112, 57, 177)',
                    color: 'rgb(112, 57, 177)',
                    padding: isMobile ? '10px 20px' : '12px 30px',
                    borderRadius: '25px',
                    fontWeight: '600',
                    textTransform: 'none',
                    fontSize: isMobile ? '13px' : '15px',
                    borderWidth: '2px',
                    transition: 'all 0.3s ease',
                    width: isMobile ? '100%' : 'auto'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = 'rgb(112, 57, 177)';
                    e.currentTarget.style.color = '#ffffff';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = 'rgb(112, 57, 177)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  Book More Tickets
                </Button>
                <Button
                  variant="outlined"
                  onClick={getQRCode}
                  style={{
                    borderColor: '#3CD4A0',
                    color: '#3CD4A0',
                    padding: isMobile ? '10px 20px' : '12px 30px',
                    borderRadius: '25px',
                    fontWeight: '600',
                    textTransform: 'none',
                    fontSize: isMobile ? '13px' : '15px',
                    borderWidth: '2px',
                    transition: 'all 0.3s ease',
                    width: isMobile ? '100%' : 'auto'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#3CD4A0';
                    e.currentTarget.style.color = '#ffffff';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#3CD4A0';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  Get QR Code
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Advertisement Banners */}
        {advtDetails.length > 0 && (
          <Grid item xs={12}>
            <Box style={{ marginTop: '20px' }}>
              {advtDetails.map(({ advatagementName, imgURL, urlLink, desc }, index) => (
                <Box key={`ad-${index}-${advatagementName || index}`} style={{ marginBottom: '20px' }}>
                  <AdvertisementBanner
                    imageUrl={imgURL && imgURL.length > 0 ? imgURL[0] : ''}
                    heading={advatagementName}
                    description={desc}
                    buttonText="Shop Now"
                    buttonUrl={urlLink}
                  />
                </Box>
              ))}
            </Box>
          </Grid>
        )}
      </Grid>

      {/* Add CSS Animation */}
      <style>
        {`
          @keyframes scaleIn {
            from {
              transform: scale(0);
              opacity: 0;
            }
            to {
              transform: scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
}


